/* eslint-disable */

/**
 * ATTENTION:
 *
 * This file is overwritten by the backend build, original template is located in:
 * `\Configuration\templates\Presentation\SOLO.Presentation.Client\src\build\env.js`
 */
export default {
    sso_url: 'https://sso.snapon.com/Login.aspx?ReturnUrl=https://solo.snapon.com',
    no_image_url: 'https://Public.Snapon.com/R_RRD/Objects_lg/images/NoImageRequired_Slug.jpg',
    web_reports_url: 'https://webreports.snapon.com',
    sales_reports_url: 'https://tableau.snapon.com/#/views/SoloReport/SOLODashboard',
    sso: {
        isUsingOldSSO: false,
        clientId: 'Solo.js',
        authRoot: 'https://login.snapon.com',
        webRoot: 'https://solo.snapon.com',
        scope: 'openid profile SoloApi'
    },
    googleTagManagerContainerId: 'GTM-N2GB7DJ'
};



// WEBPACK FOOTER //
// ./src/config/env.js